<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.user") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >

                    <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row">


                        <div class="col-lg-3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                            >
                            </base-input>
                        </div>

						<div class="col-md-2">
							<base-input>
								<el-select
									v-model="filterStatus"
									:placeholder="$t('status')"
									filterable
								>
									<el-option
										v-for="option in StatusTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-2">
							<base-input>
								<el-select
									v-model="filterGroup"
									:placeholder="$t('user_group')"
									filterable
								>
									<el-option
										v-for="option in UserGroupTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>


						</div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
							<el-table-column :label="$t('name')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.fname + " " + row.lname }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('nick_name')">
								<div slot-scope="{ row }" class="d-flex" >
									{{  row.nick_name }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('email')">
								<div slot-scope="{ row }" class="d-flex" >
									{{row.email }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('phone')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.phone }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('user_type')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ GetUserTypeName(row.group_id) }}
								</div>
							</el-table-column>


							<el-table-column :label="$t('sale_channel')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ GetSaleChannel(row.sale_channel_id) }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('department')">
								<div slot-scope="{ row }" class="d-flex" >
									 {{ GetDeaprtmentName(row.department_id) }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('status')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ GetStatusName(row.status) }}
								</div>
							</el-table-column>


                            <el-table-column
                                min-width="200px"
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
									<base-button
                                        @click.native="handleChangePassword($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-key"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >
				<form class="new-event--form" @submit.prevent="saveEvent">
					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('fname')" :name="$t('fname')" v-model="params.fname" rules="required"> </base-input>
						</div>
						<div class="col-md-6">
							<base-input :label="$t('lname')" :name="$t('lname')" v-model="params.lname" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('nick_name')" :name="$t('nick_name')" v-model="params.nick_name" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<!-- email -->
							<base-input :label="$t('email')" :name="$t('email')" v-model="params.email" rules="required|email"> </base-input>
						</div>

						<div class="col-md-6">
							<!-- phone -->
							<base-input :label="$t('phone')" :name="$t('phone')" v-model="params.phone" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<!-- Team select -->
							<base-input :label="$t('team')" >
								<el-select v-model="params.team_id" :placeholder="$t('team')" filterable >
									<el-option
										v-for="option in TeamTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-6">
							<!-- sale channel -->
							<base-input :label="$t('sale_channel')" >
								<el-select v-model="params.sale_channel_id" :placeholder="$t('sale_channel')" filterable >
									<el-option
										v-for="option in SaleChannelTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<!-- Department -->
							<base-input :label="$t('department')" >
								<el-select v-model="params.department_id" :placeholder="$t('department')" filterable >
									<el-option
										v-for="option in DepartmentTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-6">
							<!-- Department -->
							<base-input :label="$t('user_group')" >
								<el-select v-model="params.group_id" :placeholder="$t('user_group')" filterable >
									<el-option
										v-for="option in UserGroupTableFiltered"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- Department -->
							<base-input :label="$t('wms.storage_name')" >
								<el-select v-model="params.wms_storage_id" :placeholder="$t('wms.storage_name')" filterable >
									<el-option
										v-for="option in StorageTable"
										:key="option.ID"
										:label="option.Name"
										:value="option.ID"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- Department -->
							<base-input :label="$t('status')" >
								<el-select v-model="params.status" :placeholder="$t('status')" filterable >
									<el-option
										v-for="option in StatusTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- Department -->

							<base-checkbox v-model="roles.order">รายการสั่งซื้อ</base-checkbox>
							<!-- owner 2026-10-11: sub-right of รายการสั่งซื้อ (order_overview) -->
							<base-checkbox v-model="roles.order_overview" class="ml-4" :disabled="!roles.order" data-testid="role-order-overview">ภาพรวมรายการสั่งซื้อ</base-checkbox>
							<base-checkbox v-model="roles.packing">การจัดส่ง</base-checkbox>
							<base-checkbox v-model="roles.packing_admin">การจัดส่ง (Admin)</base-checkbox>
							<base-checkbox v-model="roles.payment">ตรวจสอบชำระเงิน</base-checkbox>
							<base-checkbox v-model="roles.wms">คลังสินค้า</base-checkbox>
							<base-checkbox v-model="roles.report">รายงาน</base-checkbox>
							<base-checkbox v-model="roles.product">สินค้าและโปรโมชั่น</base-checkbox>
							<base-checkbox v-model="roles.customer">ลูกค้า</base-checkbox>
							<base-checkbox v-model="roles.delivery">ระบบขนส่ง</base-checkbox>
							<base-checkbox v-model="roles.order_return">สินค้าตีกลับ</base-checkbox>
							<base-checkbox v-model="roles.po">ใบสั่งซื้อ</base-checkbox>
							<base-checkbox v-model="roles.coupon">คูปอง</base-checkbox>
							<base-checkbox v-model="roles.coupon_member">คูปอง (จัดการสมาชิก)</base-checkbox>
							<base-checkbox v-model="roles.platform_statement">Platform Statement</base-checkbox>
							<base-checkbox v-model="roles.account">บัญชี</base-checkbox>
							<base-checkbox v-model="roles.dashboard_by_platform_channel">แดชบอร์ดแพลตฟอร์ม</base-checkbox>
							<base-checkbox v-model="roles.agent_commission">{{ $t('agent_commission.permission_label') }}</base-checkbox>
							<!-- spec 2026-10-16 D14 / bo-api #980: seller access is granted in the
							     Seller Center (bo-api answers 400 if roles.seller changes here).
							     Read-only; saving keeps the stored value (userRolesForSave). -->
							<span class="d-inline-flex align-items-center" data-testid="role-seller-locked">
								<base-checkbox v-model="roles.seller" disabled>{{ $t('menu.seller') }}</base-checkbox>
								<small class="text-muted ml-1">({{ $t('seller_perm.managed_in_seller_center') }})</small>
							</span>
							<base-checkbox v-if="isSuperAdmin" v-model="roles.modern_trade">{{ $t('modern_trade.permission_label') }}</base-checkbox>
							<base-checkbox v-if="isSuperAdmin" v-model="roles.shipping_config">{{ $t('shipping_config.permission_label') }}</base-checkbox>
							<!-- Phase 1 ads §6.1: not SuperAdmin-only (Enterprise Admins may assign it) -->
							<base-checkbox v-model="roles.marketing" data-testid="role-marketing">{{ $t('marketing.role_label') }}</base-checkbox>
							<!-- Phase 3 affiliate §5.1: unmasked customer bank data + payout rounds -->
							<base-checkbox v-model="roles.affiliate_finance" data-testid="role-affiliate-finance">{{ $t('user_role.affiliate_finance') }}</base-checkbox>
						</div>
					</div>

					<div class="row mt-2">
						<div class="col-md-6">
							<label class="form-control-label">จัดการสมาชิก (Member)</label>
							<el-select v-model="roles.member" class="w-100">
								<el-option :value="0" label="ไม่มีสิทธิ์ / None"></el-option>
								<el-option :value="1" label="ดูข้อมูล / View only"></el-option>
								<el-option :value="2" label="แก้ไข / Editor"></el-option>
							</el-select>
						</div>
						<!-- #443 POS: a level, not a checkbox (1 seller / 2 supervisor / 4 admin).
						     Not SuperAdmin-gated — Enterprise Admins may assign it (spec R2). -->
						<div class="col-md-6">
							<label class="form-control-label">{{ $t('pos.role.label') }}</label>
							<!-- #448 B2: groups 1/2/99 get POS admin from the group — locked, the record keeps the user's own level -->
							<el-select v-model="roles.pos" class="w-100" :disabled="posLocked">
								<el-option :value="0" :label="$t('pos.role.none')"></el-option>
								<el-option :value="1" :label="$t('pos.role.seller')"></el-option>
								<el-option :value="2" :label="$t('pos.role.supervisor')"></el-option>
								<el-option :value="4" :label="$t('pos.role.admin')"></el-option>
							</el-select>
							<!-- POS phase 3 §13.1: BO access to the POS pages, separate from the app level -->
							<small v-if="posLocked" class="text-muted d-block pos-level-from-group">{{ $t('pos.role.from_group') }}</small>
							<base-checkbox v-model="roles.pos_bo" class="mt-2 pos-bo-check" :disabled="Number(params.group_id) === 99">{{ $t('pos.role.bo_menu') }}</base-checkbox>
							<small class="text-muted d-block">{{ $t('pos.role.bo_menu_hint') }}</small>
						</div>
					</div>



				</form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

		<!-- Modal Change Password -->
		<modal :show.sync="showChangePasswordModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidatorPassword" >
				<form class="new-event--form" @submit.prevent="saveEvent">

					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('email')" :name="$t('email')" :value="params.email" rules="required|min:6"> </base-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('password')" :name="$t('password')" v-model="params_password.password" rules="required|min:6"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('password_confirm')" :name="$t('password_confirm')" v-model="params_password.password_confirm" rules="required"> </base-input>
						</div>
					</div>
				</form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-primary"
                    @click="handleUpdatePassword()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showChangePasswordModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

    </div>
</template>
<script>
import { Table, TableColumn, Select, Option,Checkbox } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { posRoleForm, posLevelPicked, posGroupChanged, posGroupLocked, userRolesForSave, userRoleFields } from "@/utils/posRoles";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
		Checkbox
    },
	watch: {
		// #448 B1: the POS defaults follow the group / level unless the user picked them
		"params.group_id"() { posGroupChanged(this.roles, this.posState, this.params.group_id) },
		// order_overview is a sub-right of order: unticking รายการสั่งซื้อ clears it
		"roles.order"(v) { if (!v) this.roles.order_overview = false },
		"roles.pos"() { posLevelPicked(this.roles, this.posState, this.params.group_id) },
	},
    computed: {
        ...mapGetters({
            tableDataOrg: "User/getData",
			StorageTable: "WmsStorage/getDataWithAll",
			DepartmentTable: "Department/getData",
			TeamTable: "Team/getData",
			SaleChannelTable: "SaleChannel/getData",
			UserTypeTable: "User/getGroupTable",
			isSuperAdmin: "Auth/isSuperAdmin",
        }),
		// Filter UserGroupTable to hide SuperAdmin if current user is not SuperAdmin
		// #448 B2: the POS level comes from the group (Admin / Owner / SuperAdmin)
		posLocked() {
			return posGroupLocked(this.params.group_id)
		},
		UserGroupTableFiltered() {
			if (this.isSuperAdmin) {
				return this.UserGroupTable;
			}
			return this.UserGroupTable.filter(x => x.id !== 99);
		},
		tableData: function() {
			let data = this.tableDataOrg
			if(this.filterStatus != 0){
				data = data.filter(x => x.status == this.filterStatus)
			}
			if(this.filterGroup != 0){
				data = data.filter(x => x.group_id == this.filterGroup)
			}
			return data
		}
    },
    data() {
        return {
            propsToSearch: ["fname", "lname", "nick_name", "email", "phone"],
            selectedRows: [],
            showAddModal: false,
			filterGroup: 0,
			filterStatus:0,
			roles :{
				order: false,
				order_overview: false,
				packing: false,
				packing_admin: false,
				payment: false,
				wms: false,
				report: false,
				product: false,
				customer: false,
				delivery: false,
				order_return: false,
				po: false,
				coupon: false,
				coupon_member: false,
				platform_statement: false,
				account: false,
				dashboard_by_platform_channel: false,
				agent_commission: false,
				seller: false,
				modern_trade: false,
				shipping_config: false,
				marketing: false,
				affiliate_finance: false,
				member: 0,
				pos: 0,
				pos_bo: false,
			},
			// #448 B1: POS form state — the stored roles, whether pos_bo was explicit,
			// and the values last set automatically (so watchers never override a user's pick)
			posState: { stored: {}, explicit: false, storedLevel: 0, ownLevel: 0, autoBO: false },
			id:0,
			showChangePasswordModal:false,
			params_password : {
				password : "",
				password_confirm : "",
			},
			params:{
				fname : "",
				lname : "",
				nick_name : "",
				email : "",
				active : 1,
				group_id : 1,
				phone : "",
				address : "",
				district_id : "",
				city_id : "",
				province_id : "",
				zipcode : "",
				password : "",
				department_id : 1,
				team_id : 1,
				roles : "",
				sale_channel_id:1,
				status:2,
				wms_storage_id:0,
			},
			RoleTypeTable: [
				{ "id": 0,"name": "None" },
				{ "id": 1,"name": "Read" },
				{ "id": 2,"name": "Write" },
				{ "id": 4,"name": "Delete" },
				{ "id": 7,"name": "All" }
			],
			UserGroupTable:[
				{ "id": 1,"name": "Admin" },
				{ "id": 2,"name": "ผู้บริหาร" },
				{ "id": 3,"name": "พนักงาน" },
				{ "id": 4,"name": "ตัวแทน" },
				{ "id": 5,"name": "ขนส่ง" },
				{ "id": 6,"name": "ลูกค้า" },
				{ "id": 99,"name": "SuperAdmin" },
			],
			UserGroupTableWithAll:[
				{ "id": 0,"name": "--- กลุ่มผู้ใช้งาน ---" },
				{ "id": 1,"name": "Admin" },
				{ "id": 2,"name": "ผู้บริหาร" },
				{ "id": 3,"name": "พนักงาน" },
				{ "id": 4,"name": "ตัวแทน" },
				{ "id": 5,"name": "ขนส่ง" },
				{ "id": 6,"name": "ลูกค้า" },
				{ "id": 99,"name": "SuperAdmin" },
			],
			StatusTable:[
				{ "id": 2,"name": "ใช้งาน" },
				{ "id": 3,"name": "ไม่ใช้งาน" },
			],
			StatusTableWithAll:[
				{ "id": 0,"name": "--- สถานะ ---" },
				{ "id": 2,"name": "ใช้งาน" },
				{ "id": 3,"name": "ไม่ใช้งาน" },
			]
        };
    },
    mounted() {
        this.listData();
		this.listDepartment();
		this.listSaleChannel();
		this.listTeam();
		this.listStorage();
    },
    methods: {
        ...mapActions({
            createData: "User/createData",
            updateData: "User/updateData",
            deleteData: "User/deleteData",
            listData: "User/listData",
			listDepartment: "Department/listData",
			listTeam: "Team/listData",
			listSaleChannel: "SaleChannel/listData",
            listStorage: "WmsStorage/listData",
			changePassword:"User/changePassword",
        }),
        handleCreate(action) {
            this.showAddModal = true;
			this.id=0;
			this.params.fname =  ""
			this.params.lname =  ""
			this.params.nick_name =  ""
			this.params.email =  ""
			this.params.active =  1
			this.params.group_id =  1
			this.params.phone =  ""
			this.params.address =  ""
			this.params.district_id =  ""
			this.params.city_id =  ""
			this.params.province_id =  ""
			this.params.zipcode =  ""
			this.params.password =  ""
			this.params.department_id =  1
			this.params.team_id =  1
			this.params.roles =  ""
			this.params.sale_channel_id = 1
			this.params.wms_storage_id = 0
			// no role may carry over from the previously edited user (#448): every
			// checkbox off, member none — the group's defaults come from the group at login
			Object.assign(this.roles, userRoleFields({}))
			// POS starts from the group's effective level (Admin/Owner → 4, ticked), #448 B1
			this.posInit({}, this.params.group_id)
        },
		posInit(stored, group) {
			const { form, state } = posRoleForm(stored, group)
			this.posState = state
			this.roles.pos = form.pos
			this.roles.pos_bo = form.pos_bo
		},
        handleEdit(index, row) {
            this.showAddModal = true;
            this.id = row.UserID
            this.params.fname = row.fname
            this.params.lname = row.lname
            this.params.nick_name = row.nick_name
            this.params.email = row.email
            this.params.active = row.active
            this.params.group_id = row.group_id
            this.params.phone = row.phone
            this.params.address = row.address
            this.params.district_id = row.district_id
            this.params.city_id = row.city_id
            this.params.province_id = row.province_id
            this.params.zipcode = row.zipcode
            this.params.department_id = row.department_id
            this.params.team_id = row.team_id
            this.params.roles = row.roles
            this.params.sale_channel_id = row.sale_channel_id
            this.params.status = row.status
			this.params.wms_storage_id = row.wms_storage_id

			// fetch roles
			let r = JSON.parse(this.params.roles)
			Object.assign(this.roles, userRoleFields(r))
			// effective level (Admin/Owner/SuperAdmin → 4 even when roles has no "pos")
			// and the effective pos_bo (explicit key, else legacy pos >= 2), §13.1 / #448 B1
			this.posInit(r, row.group_id)
        },
        async handleUpdate() {
			// Validate
			let valid = await this.$refs.formValidator.validate()
			if (!valid) return

            this.showAddModal = false;
			// update role — merged onto the stored roles JSON so keys the form does not
			// show (kol, kol_financial, reprocess, …) survive; pos is the user's own
			// level, never the group's (#448 B1/B2)
			let r = userRolesForSave(this.posState.stored, this.roles, this.posState, this.params.group_id)
			this.params.roles = JSON.stringify(r)
            // Create

            if (this.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: err.response.data.Cause,
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
				let payload = {
					id:this.id,
					payload : this.params
				}
                this.updateData(payload)
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.fname + " " + row.lname + " ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.UserID)
                        .then(resp => {
                            this.listData();
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
		handleChangePassword(index,row){
			this.params.email = row.email
			this.id = row.UserID
			this.params_password.password = ""
			this.params_password.password_confirm = ""
			this.showChangePasswordModal = true
		},
		handleUpdatePassword(){
			// check password and confirm_password
			if(this.params_password.password != this.params_password.password_confirm){
				swal.fire({
					title: this.$t("password_not_match"),
					text: ``,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return
			}

			let payload = { id: this.id, payload: this.params_password}

			this.changePassword(payload)
                    .then(resp => {
						this.showChangePasswordModal = false
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });


		},

		GetDeaprtmentName(id){
			let name = ""
			this.DepartmentTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}
			});
			return name
		},
		GetTeamName(id){
			let name = ""
			this.TeamTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}
			});
			return name
		},
		GetStatusName(id){
			let name = ""
			if(id == 2){
				name = "ใช้งาน"
			}else if(id == 3){
				name = "ไม่ใช้งาน"
			}
			return name
		},
		GetUserTypeName(id){
			let name = ""
			this.UserTypeTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}
			});
			return name
		},
		GetSaleChannel(id){
			let name = ""
			this.SaleChannelTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}
			});
			return name
		}


    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
